<template>
  <c-container form wide>
    <c-summary-group
      :user="user"
      @submit="onSubmit"
    >
      <!-- Title -->
      <template #title>
        会員を登録しました
      </template>

      <!-- Content -->
      <template>
        <p>
          ありがとうございます。<br>
          次の内容で会員登録を完了しましたので、サービスをご利用頂けるようになりました。<br>
          登録内容に変更がある場合は、ユーザーメニューから変更頂けます。
        </p>
      </template>

      <!-- Submit button text -->
      <template #submit-text>OK</template>
    </c-summary-group>
  </c-container>
</template>

<script>
import page from '@/mixins/page'
import CSummaryGroup from '../Confirm/CSummaryGroup'

import { run } from '@/libs/a'

export default {
  name: 'Completed',
  mixins: [
    page('会員を登録しました')
  ],
  components: {
    CSummaryGroup
  },
  computed: {
    user () {
      return {
        account: this.getters['register/account'],
        profile: this.getters['register/profile'],
        license: this.getters['register/license']
      }
    }
  },
  methods: {
    /**
     * Submit ボタンが押された
     *
     * @param {Function} failed エラー時に呼び出すコールバック関数
     */
    onSubmit (failed) {
      run(async () => {
        // 会員登録を完了する
        this.dispatch('register/close')

        // ログイン後のルートに移動する
        await this.goTo(this.getters['org/loginTo'])

        // history をクリアする
        this.commit('org/clearLoginTo')
      })
    }
  }
}
</script>
